import { getInitialData } from './getInitialData';
var getInitialState = function () {
    return {
        data: getInitialData(),
        loading: 'idle',
        error: null,
    };
};
export { getInitialState };
